import type {SVGProps} from 'react'
import * as React from 'react'
const NoTaskIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="121" height="120" fill="none" viewBox="0 0 121 120" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.5 100.862C120.5 84.5793 93.6371 71.3794 60.5 71.3794C27.3629 71.3794 0.5 84.5793 0.5 100.862C0.5 117.145 120.5 117.145 120.5 100.862Z"
      fill="url(#paint0_linear_17513_7162)"
    />
    <g opacity="0.8">
      <g opacity="0.8">
        <path opacity="0.8" d="M15.5 83.3191V89.7846" stroke="#D9DADD" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M15.3268 70.345C11.4058 74.4614 9.7149 77.5919 10.254 79.7367C11.0626 82.9539 14.2807 83.4484 15.0761 83.4484C15.8715 83.4484 20.5011 83.5095 20.5011 79.2214C20.5011 76.3627 18.7763 73.4039 15.3268 70.345Z"
          fill="#D9DADD"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M101.707 81.8752V86.4011" stroke="#D9DADD" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M101.705 72.7588C98.9606 75.6836 97.777 77.9079 98.1544 79.4319C98.7204 81.7177 100.973 82.0691 101.53 82.0691C102.087 82.0691 105.327 82.1125 105.327 79.0657C105.327 77.0346 104.12 74.9322 101.705 72.7588Z"
          fill="#D9DADD"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M112.742 88.0496V91.6056" stroke="#D9DADD" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M112.914 81.3794C110.823 83.5459 109.921 85.1936 110.208 86.3224C110.64 88.0157 112.356 88.276 112.78 88.276C113.204 88.276 115.673 88.3081 115.673 86.0512C115.673 84.5466 114.754 82.9894 112.914 81.3794Z"
          fill="#D9DADD"
        />
      </g>
    </g>
    <g filter="url(#filter0_f_17513_7162)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8125 75.1726H38.0323L56.3642 90.0002L38.3589 89.3067L19.8125 75.1726Z"
        fill="url(#paint1_linear_17513_7162)"
      />
    </g>
    <path
      d="M79.8122 34.8279H40.1571C38.6335 34.8279 37.3984 36.063 37.3984 37.5865V87.2417C37.3984 88.7652 38.6335 90.0003 40.1571 90.0003H79.8122C81.3358 90.0003 82.5709 88.7652 82.5709 87.2417V37.5865C82.5709 36.063 81.3358 34.8279 79.8122 34.8279Z"
      fill="url(#paint2_linear_17513_7162)"
    />
    <path
      d="M60.8493 40.345C63.8964 40.345 66.3665 37.8749 66.3665 34.8278C66.3665 31.7807 63.8964 29.3105 60.8493 29.3105C57.8022 29.3105 55.332 31.7807 55.332 34.8278C55.332 37.8749 57.8022 40.345 60.8493 40.345Z"
      fill="url(#paint3_linear_17513_7162)"
    />
    <path
      d="M62.2274 29.3105C65.2745 29.3105 67.7446 31.7807 67.7446 34.8278H81.8825C83.4061 34.8278 84.6412 36.0629 84.6412 37.5864V87.2416C84.6412 88.7651 83.4061 90.0002 81.8825 90.0002H42.2274C40.7038 90.0002 39.4688 88.7651 39.4688 87.2416V37.5864C39.4688 36.0629 40.7038 34.8278 42.2274 34.8278H56.7101C56.7101 31.7807 59.1803 29.3105 62.2274 29.3105Z"
      fill="url(#paint4_linear_17513_7162)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.2212 85.3775C78.0844 86.0589 70.6708 86.3355 59.9805 86.2072L80.2475 79.0107C81.0791 82.3863 81.737 84.5086 82.2212 85.3775Z"
      fill="url(#paint5_linear_17513_7162)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.5664 40.345H81.8768C81.5185 57.1747 81.3393 67.3029 81.3393 70.7294C81.3393 75.8693 82.1065 80.1943 83.173 83.5698C78.6937 84.9037 69.5541 86.207 62.2216 86.207C57.3332 86.207 51.2739 85.7992 44.0436 84.9836C43.0588 84.4996 42.5664 79.567 42.5664 70.1858C42.5664 60.8046 42.5664 50.8577 42.5664 40.345Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M77.3956 46.207H48.0853C47.5139 46.207 47.0508 46.6702 47.0508 47.2415C47.0508 47.8128 47.5139 48.276 48.0853 48.276H77.3956C77.9669 48.276 78.4301 47.8128 78.4301 47.2415C78.4301 46.6702 77.9669 46.207 77.3956 46.207Z"
      fill="#D9DADD"
    />
    <path
      opacity="0.5"
      d="M77.3956 51.0347H48.0853C47.5139 51.0347 47.0508 51.4978 47.0508 52.0691C47.0508 52.6405 47.5139 53.1036 48.0853 53.1036H77.3956C77.9669 53.1036 78.4301 52.6405 78.4301 52.0691C78.4301 51.4978 77.9669 51.0347 77.3956 51.0347Z"
      fill="#D9DADD"
    />
    <path
      opacity="0.5"
      d="M62.9128 55.8623H48.0853C47.5139 55.8623 47.0508 56.3255 47.0508 56.8968C47.0508 57.4681 47.5139 57.9313 48.0853 57.9313H62.9128C63.4842 57.9313 63.9473 57.4681 63.9473 56.8968C63.9473 56.3255 63.4842 55.8623 62.9128 55.8623Z"
      fill="#D9DADD"
    />
    <path
      opacity="0.5"
      d="M52.9128 76.8967H48.0853C47.5139 76.8967 47.0508 77.3599 47.0508 77.9312C47.0508 78.5025 47.5139 78.9657 48.0853 78.9657H52.9128C53.4842 78.9657 53.9473 78.5025 53.9473 77.9312C53.9473 77.3599 53.4842 76.8967 52.9128 76.8967Z"
      fill="#D9DADD"
    />
    <path
      d="M62.2245 37.931C63.9385 37.931 65.328 36.5416 65.328 34.8276C65.328 33.1136 63.9385 31.7241 62.2245 31.7241C60.5106 31.7241 59.1211 33.1136 59.1211 34.8276C59.1211 36.5416 60.5106 37.931 62.2245 37.931Z"
      fill="url(#paint6_linear_17513_7162)"
    />
    <path
      d="M61.8797 37.5863C63.4033 37.5863 64.6383 36.3513 64.6383 34.8277C64.6383 33.3042 63.4033 32.0691 61.8797 32.0691C60.3562 32.0691 59.1211 33.3042 59.1211 34.8277C59.1211 36.3513 60.3562 37.5863 61.8797 37.5863Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_f_17513_7162"
        x="18.4792"
        y="73.8393"
        width="39.2174"
        height="17.4943"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_17513_7162" />
      </filter>
      <linearGradient
        id="paint0_linear_17513_7162"
        x1="60.5"
        y1="71.3794"
        x2="60.5"
        y2="109.793"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DADD" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_17513_7162"
        x1="44.5088"
        y1="82.1934"
        x2="44.957"
        y2="83.8107"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DADD" stopOpacity="0" />
        <stop offset="1" stopColor="#D9DADD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_17513_7162"
        x1="59.9846"
        y1="90.0003"
        x2="59.9846"
        y2="34.8279"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBCCCF" />
        <stop offset="1" stopColor="#EFEFEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_17513_7162"
        x1="60.8493"
        y1="40.345"
        x2="60.8493"
        y2="29.3105"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DADD" />
        <stop offset="1" stopColor="#EDEDED" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_17513_7162"
        x1="62.055"
        y1="84.6425"
        x2="62.055"
        y2="34.2654"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DADD" />
        <stop offset="1" stopColor="#F2F2F2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_17513_7162"
        x1="71.1008"
        y1="86.2377"
        x2="71.1008"
        y2="79.0107"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CACBCF" />
        <stop offset="1" stopColor="#EDEDEE" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_17513_7162"
        x1="62.2245"
        y1="37.931"
        x2="62.2245"
        y2="31.7241"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#D9DADD" />
        <stop offset="1" stopColor="#EEEEEF" />
      </linearGradient>
    </defs>
  </svg>
)
export default NoTaskIcon
